<!--
 * @Description: 半导体行业：解决方案
-->
<template>
  <div class="semiconductor_solution"
    :class="{ 'semiconductor_solution_en': $i18n.locale === 'en_US', 'semiconductor_solution_en semiconductor_solution_ja': $i18n.locale === 'ja_JP' }">
    <div class="semiconductor_content">
      <div class="solution_img">
        <div class="solution_content">
          <!-- 左边 -->
          <div>
            <div class="sem_lh_lg lt01_1  solution_position position ">
              <div class="icon_title">
                <div class="content_icon">
                  <img class="content_icon_img"
                    src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_yes.png" />
                </div>
                <div class="solution_position title s_title">
                  {{
                    $t(
                      "solution.semiconductor.solutions.image.tab01.title_top01"
                    )
                  }}
                </div>
              </div>
              <div class="icon_title">
                <div class="content_icon">
                  <img class="content_icon_img"
                    src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_yes.png" />
                </div>
                <div class="solution_position title s_title">
                  {{
                    $t(
                      "solution.semiconductor.solutions.image.tab01.title_top02"
                    )
                  }}
                </div>
              </div>
              <div class="icon_title">
                <div class="content_icon">
                  <img class="content_icon_img"
                    src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_yes.png" />
                </div>
                <div class="solution_position title s_title">
                  {{
                    $t(
                      "solution.semiconductor.solutions.image.tab01.title_top03"
                    )
                  }}
                </div>
              </div>
            </div>
            <div class=" sem_lh-1 lt01_2  solution_position position title">
              <div class="solution_position number">01</div>
              <div class="mt--10">
                {{ $t("solution.semiconductor.solutions.image.tab01.title") }}
              </div>
            </div>
            <div class="lb01 sem_lh-1 solution_position position d_title display_dir_col">
              <div class="display_center div_height">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab01.title_bottom01"
                  )
                }}
              </div>
              <div class="display_center div_height div_padding">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab01.title_bottom02"
                  )
                }}
              </div>
              <div class="display_center div_height">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab01.title_bottom03"
                  )
                }}
              </div>
            </div>
          </div>
          <div>
            <div class="sem_lh_lg lt02_1  solution_position position">
              <div class="icon_title">
                <div class="content_icon">
                  <img class="content_icon_img"
                    src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_yes.png" />
                </div>
                <div class="solution_position title s_title">
                  {{
                    $t(
                      "solution.semiconductor.solutions.image.tab02.title_top01"
                    )
                  }}
                </div>
              </div>
              <div class="icon_title">
                <div class="content_icon">
                  <img class="content_icon_img"
                    src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_yes.png" />
                </div>
                <div class="solution_position title s_title">
                  {{
                    $t(
                      "solution.semiconductor.solutions.image.tab02.title_top02"
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="lt02_2 sem_lh-1 solution_position position title">
              <div class="solution_position number">02</div>
              <div class="div_mt">
                {{ $t("solution.semiconductor.solutions.image.tab02.title") }}
              </div>
            </div>
            <div class="lb02 sem_lh-1 solution_position position d_title display_dir_col">
              <div class="display_center div_height">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab02.title_bottom01"
                  )
                }}
              </div>
              <div class="display_center div_height">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab02.title_bottom02"
                  )
                }}
              </div>
              <div class="display_center div_height">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab02.title_bottom03"
                  )
                }}
              </div>
              <div class="display_center div_height">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab02.title_bottom04"
                  )
                }}
              </div>
            </div>
          </div>
          <div>
            <div class="lt03_1 sem_lh_lg solution_position position">
              <div class="icon_title">
                <div class="content_icon">
                  <img class="content_icon_img"
                    src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_yes.png" />
                </div>
                <div class="solution_position title s_title">
                  {{
                    $t("solution.semiconductor.solutions.image.tab03.title_top")
                  }}
                </div>
              </div>
            </div>
            <div class="lt03_2 sem_lh-1 solution_position position title">
              <div class="solution_position number">03</div>
              <div class="div_mt">
                {{ $t("solution.semiconductor.solutions.image.tab03.title") }}
              </div>
            </div>
            <div class="lb03 sem_lh-1 sem_lh-1_ja solution_position position d_title display_center div_height2">
              {{
                $t("solution.semiconductor.solutions.image.tab03.title_bottom")
              }}
              <!-- 研发、生产、外协业务版块多<br />专业信息系统 -->
            </div>
          </div>
          <!-- 右边 -->
          <div>
            <div class="rt04_1 sem_lh_lg solution_position position">
              <div class="icon_title">
                <div class="content_icon">
                  <img class="content_icon_img"
                    src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_yes.png" />
                </div>
                <div class="solution_position title s_title">
                  {{
                    $t("solution.semiconductor.solutions.image.tab04.title_top")
                  }}
                </div>
              </div>
            </div>
            <div class="rt04_2 sem_lh-1 solution_position position title">
              <div class="solution_position number">04</div>
              <div class="div_mt">
                {{ $t("solution.semiconductor.solutions.image.tab04.title") }}
              </div>
            </div>
            <div class="rb04 sem_lh-1 solution_position position d_title display_dir_col">
              <div class="display_center div_height2">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab04.title_bottom01"
                  )
                }}
              </div>
              <div class="display_center div_height2">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab04.title_bottom02"
                  )
                }}
              </div>
              <div class="display_center div_height2">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab04.title_bottom03"
                  )
                }}
              </div>
            </div>
          </div>
          <div>
            <div class="rt05_1 sem_lh_lg solution_position position">
              <div class="icon_title">
                <div class="content_icon">
                  <img class="content_icon_img"
                    src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_yes.png" />
                </div>
                <div class="solution_position title s_title">
                  {{
                    $t("solution.semiconductor.solutions.image.tab05.title_top")
                  }}
                </div>
              </div>
            </div>
            <div class="rt05_2 sem_lh-1 solution_position position title">
              <div class="solution_position number">05</div>
              <div class="div_mt">
                {{ $t("solution.semiconductor.solutions.image.tab05.title") }}
              </div>
            </div>
            <div class="rb05 sem_lh-1 solution_position position d_title display_dir_col">
              <div class="display_center div_height2">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab05.title_bottom01"
                  )
                }}
              </div>
              <div class="display_center div_height">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab05.title_bottom02"
                  )
                }}
              </div>
            </div>
          </div>
          <div>
            <div class="rt06_1 sem_lh_lg solution_position position">
              <div class="icon_title">
                <div class="content_icon">
                  <img class="content_icon_img"
                    src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_yes.png" />
                </div>
                <div class="solution_position title s_title">
                  {{
                    $t("solution.semiconductor.solutions.image.tab06.title_top")
                  }}
                </div>
              </div>
            </div>
            <div class="rt06_2 sem_lh-1 solution_position position title">
              <div class="solution_position number">06</div>
              <div class="div_mt">
                {{ $t("solution.semiconductor.solutions.image.tab06.title") }}
              </div>
            </div>
            <div class="rb06 sem_lh-1 solution_position position d_title display_dir_col">
              <div class="display_center div_height">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab06.title_bottom01"
                  )
                }}
              </div>
              <div class="display_center div_height">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab06.title_bottom02"
                  )
                }}
              </div>
              <div class="display_center div_height">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab06.title_bottom03"
                  )
                }}
              </div>
              <div class="display_center div_height">
                {{
                  $t(
                    "solution.semiconductor.solutions.image.tab06.title_bottom04"
                  )
                }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="solution_card pt--20">
      <div class="card_content ptb_sm--10">
        <div class="card_icon d-none d-sm-block">
          <img class="card_icon_img" src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_01.png" />
        </div>
        <div>
          <div class="card_content2">
            <div class="card_icon2 d-blok d-sm-none">
              <img class="card_icon_img2"
                src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_01.png" />
            </div>
            <div class="f_title">
              {{ $t("solution.semiconductor.solutions.card.card01.title") }}
            </div>
          </div>
          <div class="title s_title ptb--10">
            {{
              $t("solution.semiconductor.solutions.card.card01.description01")
            }}
          </div>
          <div class="title s_title">
            {{
              $t("solution.semiconductor.solutions.card.card01.description02")
            }}
          </div>
        </div>
      </div>
      <div class="card_content ptb_sm--10">
        <div class="card_icon d-none d-sm-block">
          <img class="card_icon_img" src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_02.png" />
        </div>
        <div>
          <div class="card_content2">
            <div class="card_icon2 d-blok d-sm-none">
              <img class="card_icon_img2"
                src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_02.png" />
            </div>
            <div class="f_title">
              {{ $t("solution.semiconductor.solutions.card.card02.title") }}
            </div>
          </div>
          <div class="title s_title ptb--10">
            <strong>
              {{
                $t(
                  "solution.semiconductor.solutions.card.card02.description_title01"
                )
              }}</strong>
            {{
              $t("solution.semiconductor.solutions.card.card02.description01")
            }}
          </div>
          <div class="title s_title">
            <strong>
              {{
                $t(
                  "solution.semiconductor.solutions.card.card02.description_title02"
                )
              }}</strong>
            {{
              $t("solution.semiconductor.solutions.card.card02.description02")
            }}
          </div>
        </div>
      </div>
      <div class="card_content ptb_sm--10">
        <div class="card_icon d-none d-sm-block">
          <img class="card_icon_img" src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_03.png" />
        </div>
        <div>
          <div class="card_content2">
            <div class="card_icon2 d-blok d-sm-none">
              <img class="card_icon_img2"
                src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_03.png" />
            </div>
            <div class="f_title">
              {{ $t("solution.semiconductor.solutions.card.card03.title") }}
            </div>
          </div>
          <div class="title s_title ptb--10">
            {{
              $t("solution.semiconductor.solutions.card.card03.description01")
            }}
          </div>
          <div class="title s_title">
            <strong>
              {{
                $t(
                  "solution.semiconductor.solutions.card.card03.description_title01"
                )
              }}</strong>
            {{
              $t("solution.semiconductor.solutions.card.card03.description02")
            }}
          </div>
          <div class="title s_title ptb--10">
            <strong>
              {{
                $t(
                  "solution.semiconductor.solutions.card.card03.description_title02"
                )
              }}</strong>
            {{
              $t("solution.semiconductor.solutions.card.card03.description03")
            }}
          </div>
          <div class="title s_title">
            <strong>
              {{
                $t(
                  "solution.semiconductor.solutions.card.card03.description_title03"
                )
              }}</strong>
            {{
              $t("solution.semiconductor.solutions.card.card03.description04")
            }}
          </div>
          <div class="title s_title pt--10">
            <strong>
              {{
                $t(
                  "solution.semiconductor.solutions.card.card03.description_title04"
                )
              }}</strong>
            {{
              $t("solution.semiconductor.solutions.card.card03.description05")
            }}
          </div>
        </div>
      </div>
      <div class="card_content ptb_sm--10">
        <div class="card_icon d-none d-sm-block">
          <img class="card_icon_img" src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_04.png" />
        </div>
        <div>
          <div class="card_content2">
            <div class="card_icon2 d-blok d-sm-none">
              <img class="card_icon_img2"
                src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_04.png" />
            </div>
            <div class="f_title">
              {{ $t("solution.semiconductor.solutions.card.card04.title") }}
            </div>
          </div>
          <div class="title s_title pt--10">
            {{ $t("solution.semiconductor.solutions.card.card04.description") }}
          </div>
        </div>
      </div>
      <div class="card_content ptb_sm--10">
        <div class="card_icon d-none d-sm-block">
          <img class="card_icon_img" src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_05.png" />
        </div>
        <div>
          <div class="card_content2">
            <div class="card_icon2 d-blok d-sm-none">
              <img class="card_icon_img2"
                src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_05.png" />
            </div>
            <div class="f_title">
              {{ $t("solution.semiconductor.solutions.card.card05.title") }}
            </div>
          </div>
          <div class="title s_title ptb--10">
            {{
              $t("solution.semiconductor.solutions.card.card05.description01")
            }}
          </div>
          <div class="title s_title">
            {{
              $t("solution.semiconductor.solutions.card.card05.description02")
            }}
          </div>
          <div class="title s_title pt--10">
            {{
              $t("solution.semiconductor.solutions.card.card05.description03")
            }}
          </div>
        </div>
      </div>
      <div class="card_content ptb_sm--10">
        <div class="card_icon d-none d-sm-block">
          <img class="card_icon_img" src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_06.png" />
        </div>
        <div>
          <div class="card_content2">
            <div class="card_icon2 d-blok d-sm-none">
              <img class="card_icon_img2"
                src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_06.png" />
            </div>
            <div class="f_title">
              {{ $t("solution.semiconductor.solutions.card.card06.title") }}
            </div>
          </div>
          <div class="title s_title ptb--10">
            {{
              $t("solution.semiconductor.solutions.card.card06.description01")
            }}
          </div>
          <div class="title s_title">
            {{
              $t("solution.semiconductor.solutions.card.card06.description02")
            }}
          </div>
        </div>
      </div>
      <div class="card_content ptb_sm--10">
        <div class="card_icon d-none d-sm-block">
          <img class="card_icon_img" src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_07.png" />
        </div>
        <div>
          <div class="card_content2">
            <div class="card_icon2 d-blok d-sm-none">
              <img class="card_icon_img2"
                src="../../assets/images/IndustrySolution/semiconductor/semiconductor_icon_07.png" />
            </div>
            <div class="f_title">
              {{ $t("solution.semiconductor.solutions.card.card07.title") }}
            </div>
          </div>
          <div class="title s_title pt--10">
            {{ $t("solution.semiconductor.solutions.card.card07.description") }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SemiconductorSolution',
}
</script>